import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { EditProjectPayload } from '@/api/v4/projects.api';
import { editProject } from '@/api/v4/projects.api';
import { QueryKey } from '@/config/query-client';

import { projectIdState } from '../project.state';
import { useAtomValue } from 'jotai';

export const useUpdateProject = () => {
  const queryClient = useQueryClient();
  const projectId = useAtomValue(projectIdState);

  const mutation = useMutation({
    mutationFn: (data: EditProjectData) => {
      const { projectId, ...payload } = data;
      return editProject(projectId, payload);
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: [QueryKey.Projects] }),
        queryClient.invalidateQueries({ queryKey: [QueryKey.ProjectsKpi] }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.Project, projectId],
        }),
        queryClient.invalidateQueries({ queryKey: [QueryKey.ProjectOptions] }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.ProjectFiltersTeamOptions],
        }),
        queryClient.invalidateQueries({ queryKey: [QueryKey.ProjectCreators] }),
        queryClient.invalidateQueries({ queryKey: [QueryKey.LastActivities] }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.LastActivitiesCount],
        }),
      ]);
    },
  });

  return {
    editProject: mutation.mutateAsync,
    isError: mutation.isError,
  };
};

interface EditProjectData extends EditProjectPayload {
  projectId: string;
}
